<template>
      <div no-body class="lku-coa"> 
      <b-row>
        <b-col lg="8">
          <b-form-group label-cols=2 label="Filter ">
              <b-row>
                <b-col class="pr-1" cols="4"><b-form-input v-model="filter.KdKompGaji" @keyup.13.native="refresh()" placeholder="Code"></b-form-input></b-col>
                <b-col class="pl-1" cols="8"><b-form-input v-model="filter.NmKompGaji" @keyup.13.native="refresh()" placeholder="Name"></b-form-input></b-col>
              </b-row>                      
          </b-form-group>
        </b-col>
        <b-col lg="3">
            <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
        </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblCoa" style="font-size:smaller;" 
          responsive small striped hover
          :items="data"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
        >
        </b-table>
        <b-row>
          <b-col cols="6">
            <div>
              Showing {{(tblData.page - 1) * tblData.limit + 1}}
              to
              <span
                v-if="((tblData.page * tblData.limit)>tblData.total)"
              >{{tblData.total}}</span>
              <span v-else>{{tblData.page * tblData.limit}}</span>
              of {{tblData.total}} entries,
              <span
                class="ml-3 mr-1"
              >limit per page :</span>
              <select v-model="tblData.limit" style="width:60px;">
                <option>10</option>
                <option>15</option>
                <option>20</option>
                <option>25</option>
                <option>30</option>
              </select>
            </div>
          </b-col>
          <b-col cols="6">
            <b-pagination
              align="right"
              :total-rows="tblData.total"
              :per-page="tblData.limit"
              v-model="tblData.page"
            ></b-pagination>
          </b-col>
        </b-row>
    </div>
</template>
<style lang="scss">
  .lku-coa {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import crud from "../../apis/crud";
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      fields: [
          {
            key: "KdKompGaji",
            label: "Item Code",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "NmKompGaji",
            label: "Item Name",
            sortable: true
          },
          {
            key: "JenisKomp",
            label: "Item Type",
            sortable: true
          },
          {
            key: "TakeHome",
            label: "Take Home Pay",
            thStyle: "width:140px",
            sortable: true
          },
      ],
      filter : {KdKompGaji:'', NmKompGaji:''},
      tblData: {
        tablename:'komponengaji',
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'TakeHome',
        sortDesc: true
      },
    };
  },
  computed: {
    filterNamaAcc() {
      return this.filter.NmKompGaji;
    },
  },
  watch: {
    filterNamaAcc: function(NmKompGaji) {
      setTimeout(() => {
        if (NmKompGaji == this.filter.NmKompGaji) this.refresh();
      }, 500);
    },    
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.customQuery='';
      let str='';
      if (this.filter.NmKompGaji){
        str = 'NmKompGaji=%' + encodeURIComponent(this.filter.NmKompGaji)+'%';
      }
      if (this.filter.KdKompGaji){
        str += str ? '&' : '';
        str = str + 'KdKompGaji=' + encodeURIComponent(this.filter.KdKompGaji)+'%';
      }
      this.tblData.customQuery=str;
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

    return await crud.list(this.tblData);      

    },
    selectItem(item,index) {
      this.$emit("click", item);
    },
    clearFilter() {
        this.filter={KdKompGaji:'', NmKompGaji: ''};
        this.refresh();
    },    
    keymonitor: function(event) {
        console.log(event.key);
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblCoa.refresh();
       }
    },    
    refresh() {
      this.$refs.tblCoa.refresh();
    }
  }
};
</script>
